import React, { useRef, useEffect, forwardRef } from 'react'

const TextArea = forwardRef((props, ref) => {
  const textareaRef = useRef(null)

  // Use the forwarded ref if provided, otherwise use the internal ref
  const finalRef = ref || textareaRef

  useEffect(() => {
    if (finalRef.current) {
      finalRef.current.style.height = '0px'
      const scrollHeight = finalRef.current.scrollHeight
      finalRef.current.style.height = scrollHeight + 'px'
    }
  }, [props, finalRef])

  return (
    <textarea
      ref={finalRef}
      rows={'1'}
      placeholder='Type your answer here...'
      className='bg-transparent s13 focus-visible resize-none mb-3 border-0 w-100'
      style={{ color: '#fff' }}
      {...props}
    />
  )
})

export default TextArea
